
// import React, { useState } from 'react';
// import { Button, Tag } from 'antd';
// import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';

// const DragDropImage = ({ 
//   imageUrl, 
//   dropZones = [], 
//   propositions = [], 
//   onAnswerChange, 
//   showCorrectAnswers = false 
// }) => {
//   const [userAnswers, setUserAnswers] = useState({});
//   const [draggedItem, setDraggedItem] = useState(null);

//   const handleDragStart = (proposition) => {
//     setDraggedItem(proposition);
//   };

//   const handleDrop = (zoneId) => {
//     if (draggedItem) {
//       const newAnswers = {
//         ...userAnswers,
//         [zoneId]: draggedItem
//       };
//       setUserAnswers(newAnswers);
//       onAnswerChange?.({ [zoneId]: draggedItem.content });
//       setDraggedItem(null);
//     }
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//   };

//   const isCorrect = (zoneId) => {
//     if (!showCorrectAnswers) return null;
//     const zone = dropZones.find(z => z.id === zoneId);
//     return userAnswers[zoneId]?.content === zone?.correctAnswer;
//   };

//   const getZoneStyle = (zone) => {
//     const baseStyle = {
//       position: 'absolute',
//       left: `${zone.x}%`,
//       top: `${zone.y}%`,
//       width: `${zone.width || 15}%`,
//       height: `${zone.height || 8}%`,
//       borderRadius: '4px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       fontSize: '11px',
//       fontWeight: '600',
//       cursor: 'pointer',
//       transition: 'all 0.3s',
//       padding: '4px'
//     };

//     if (showCorrectAnswers) {
//       const correct = isCorrect(zone.id);
//       return {
//         ...baseStyle,
//         border: `2px solid ${correct ? '#52c41a' : '#ff4d4f'}`,
//         backgroundColor: correct ? 'rgba(82, 196, 26, 0.1)' : 'rgba(255, 77, 79, 0.1)'
//       };
//     }

//     return {
//       ...baseStyle,
//       border: userAnswers[zone.id] 
//         ? '2px solid #52c41a' 
//         : '2px dashed #1890ff',
//       backgroundColor: userAnswers[zone.id] 
//         ? 'rgba(82, 196, 26, 0.1)' 
//         : 'rgba(24, 144, 255, 0.05)'
//     };
//   };

//   return (
//     <div style={{ 
//       display: 'flex', 
//       gap: '20px', 
//       padding: '16px',
//       background: 'white',
//       borderRadius: '8px'
//     }}>
//       {/* Image avec zones de drop */}
//       <div style={{ 
//         position: 'relative', 
//         flex: 1,
//         border: '2px solid #e8e8e8',
//         borderRadius: '8px',
//         overflow: 'hidden',
//         minHeight: '400px'
//       }}>
//         <img 
//           src={imageUrl} 
//           alt="Drop zones" 
//           style={{ 
//             width: '100%', 
//             display: 'block',
//             userSelect: 'none'
//           }}
//           draggable={false}
//         />
        
//         {/* Zones de drop positionnées sur l'image */}
//         {dropZones.map(zone => (
//           <div
//             key={zone.id}
//             onDragOver={handleDragOver}
//             onDrop={() => handleDrop(zone.id)}
//             style={getZoneStyle(zone)}
//           >
//             {userAnswers[zone.id] ? (
//               <div style={{ 
//                 background: 'white', 
//                 padding: '4px 8px', 
//                 borderRadius: '4px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '4px',
//                 boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//               }}>
//                 {showCorrectAnswers && (
//                   isCorrect(zone.id) 
//                     ? <CheckCircleTwoTone twoToneColor="#52c41a" />
//                     : <CloseCircleTwoTone twoToneColor="#ff4d4f" />
//                 )}
//                 <span style={{ fontSize: '11px' }}>
//                   {userAnswers[zone.id].content}
//                 </span>
//               </div>
//             ) : (
//               <span style={{ color: '#1890ff', textAlign: 'center' }}>
//              ...... 
//               </span>
//             )}
//           </div>
//         ))}
//       </div>

//       {/* Propositions draggables */}
//       <div style={{ 
//         width: '250px',
//         background: '#f8f9fa',
//         padding: '16px',
//         borderRadius: '8px',
//         border: '1px solid #e8e8e8'
//       }}>
//         <h4 style={{ 
//           marginBottom: '12px', 
//           fontSize: '13px',
//           color: '#1890ff',
//           fontWeight: '600'
//         }}>
//           📦 Propositions disponibles
//         </h4>
//         <div style={{ 
//           display: 'flex', 
//           flexDirection: 'column', 
//           gap: '8px' 
//         }}>
//           {propositions.map(prop => (
//             <div
//               key={prop.id}
//               draggable
//               onDragStart={() => handleDragStart(prop)}
//               style={{
//                 padding: '10px',
//                 background: 'white',
//                 border: '2px solid #d9d9d9',
//                 borderRadius: '6px',
//                 cursor: 'grab',
//                 fontSize: '12px',
//                 fontWeight: '500',
//                 textAlign: 'center',
//                 transition: 'all 0.2s',
//                 userSelect: 'none'
//               }}
//               onMouseDown={(e) => e.currentTarget.style.cursor = 'grabbing'}
//               onMouseUp={(e) => e.currentTarget.style.cursor = 'grab'}
//             >
//               {prop.content}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DragDropImage;



import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Button, Tag } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';

const DragDropImage = ({
  imageUrl,
  dropZones = [],
  propositions = [],
  onAnswerChange,
  showCorrectAnswers = false,
  initialFilledZones = {}
}) => {
  const [userAnswers, setUserAnswers] = useState({});
  const [draggedItem, setDraggedItem] = useState(null);

  // 🆕 Refs et state pour le calcul d'offset image
  const containerRef = useRef(null);
  const imgRef = useRef(null);
  const [imageLayout, setImageLayout] = useState(null);

  // 🆕 Initialiser les réponses pré-remplies (review mode)
  useEffect(() => {
    if (initialFilledZones && Object.keys(initialFilledZones).length > 0) {
      const restored = {};
      Object.entries(initialFilledZones).forEach(([zoneId, content]) => {
        const prop = propositions.find(
          p => p.content === content || p.propositionContent === content || p.text === content
        );
        if (prop) {
          restored[zoneId] = prop;
        } else {
          restored[zoneId] = { id: `restored-${zoneId}`, content };
        }
      });
      setUserAnswers(restored);
    }
  }, [initialFilledZones, propositions]);

  // 🆕 Calculer la position réelle de l'image dans le conteneur
  const computeImageLayout = useCallback(() => {
    const img = imgRef.current;
    const container = containerRef.current;
    if (!img || !container || !img.naturalWidth || !img.naturalHeight) return;

    const containerW = container.clientWidth;
    const containerH = container.clientHeight;
    const naturalW = img.naturalWidth;
    const naturalH = img.naturalHeight;

    // L'image utilise width:100%, donc :
    const renderedW = containerW;
    const renderedH = (naturalH / naturalW) * containerW;

    // Offset si l'image est plus petite que le conteneur en hauteur
    const offsetX = 0; // width:100% donc pas de décalage horizontal
    const offsetY = 0; // L'image commence en haut

    setImageLayout({
      renderedW,
      renderedH,
      offsetX,
      offsetY,
      containerW,
      containerH: Math.max(containerH, renderedH)
    });
  }, []);

  // 🆕 Recalculer au resize
  useEffect(() => {
    const handleResize = () => computeImageLayout();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [computeImageLayout]);

  // 🆕 Convertir les % de zone (relatifs à l'image) en pixels absolus dans le conteneur
  const getZonePixelPosition = (zone) => {
    if (!imageLayout) {
      // Fallback : utiliser les % directement (ancien comportement)
      return {
        left: `${zone.x}%`,
        top: `${zone.y}%`,
        width: `${zone.width || 15}%`,
        height: `${zone.height || 8}%`
      };
    }

    const { renderedW, renderedH, offsetX, offsetY } = imageLayout;

    return {
      left: `${offsetX + (zone.x / 100) * renderedW}px`,
      top: `${offsetY + (zone.y / 100) * renderedH}px`,
      width: `${((zone.width || 15) / 100) * renderedW}px`,
      height: `${((zone.height || 8) / 100) * renderedH}px`
    };
  };

  const handleDragStart = (proposition) => {
    setDraggedItem(proposition);
  };

  const handleDrop = (zoneId) => {
    if (draggedItem) {
      const newAnswers = {
        ...userAnswers,
        [zoneId]: draggedItem
      };
      setUserAnswers(newAnswers);
      onAnswerChange?.({ [zoneId]: draggedItem.content });
      setDraggedItem(null);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // 🆕 Retirer une réponse d'une zone (clic pour supprimer)
  const handleRemoveAnswer = (zoneId) => {
    if (showCorrectAnswers) return; // Pas de modification en mode review
    const newAnswers = { ...userAnswers };
    delete newAnswers[zoneId];
    setUserAnswers(newAnswers);
    onAnswerChange?.({ [zoneId]: null });
  };

  const isCorrect = (zoneId) => {
    if (!showCorrectAnswers) return null;
    const zone = dropZones.find(z => z.id === zoneId || z.id?.toString() === zoneId?.toString());
    return userAnswers[zoneId]?.content === zone?.correctAnswer;
  };

  const getZoneStyle = (zone) => {
    const pixelPos = getZonePixelPosition(zone);

    const baseStyle = {
      position: 'absolute',
      left: pixelPos.left,
      top: pixelPos.top,
      width: pixelPos.width,
      height: pixelPos.height,
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '11px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s',
      padding: '2px',
      boxSizing: 'border-box',
      overflow: 'hidden',
      zIndex: 2
    };

    if (showCorrectAnswers) {
      const correct = isCorrect(zone.id);
      return {
        ...baseStyle,
        border: `2px solid ${correct ? '#52c41a' : '#ff4d4f'}`,
        backgroundColor: correct ? 'rgba(82, 196, 26, 0.15)' : 'rgba(255, 77, 79, 0.15)'
      };
    }

    return {
      ...baseStyle,
      border: userAnswers[zone.id]
        ? '2px solid #52c41a'
        : '2px dashed #1890ff',
      backgroundColor: userAnswers[zone.id]
        ? 'rgba(82, 196, 26, 0.1)'
        : 'rgba(24, 144, 255, 0.08)'
    };
  };

  // 🆕 Vérifier quelles propositions sont déjà placées
  const usedPropositionIds = new Set(
    Object.values(userAnswers).map(a => a?.id).filter(Boolean)
  );

  return (
    <div style={{
      display: 'flex',
      gap: '16px',
      padding: '12px',
      background: 'white',
      borderRadius: '8px'
    }}>
      {/* Image avec zones de drop */}
      <div
        ref={containerRef}
        style={{
          position: 'relative',
          flex: 1,
          border: '2px solid #e8e8e8',
          borderRadius: '8px',
          overflow: 'hidden',
          lineHeight: 0 // 🆕 Supprime l'espace fantôme sous l'image
        }}
      >
        <img
          ref={imgRef}
          src={imageUrl}
          alt="Drop zones"
          style={{
            width: '100%',
            display: 'block',
            userSelect: 'none'
          }}
          draggable={false}
          onLoad={computeImageLayout}
        />

        {/* Zones de drop positionnées sur l'image */}
        {dropZones.map(zone => (
          <div
            key={zone.id}
            onDragOver={handleDragOver}
            onDrop={() => handleDrop(zone.id)}
            onClick={() => userAnswers[zone.id] && handleRemoveAnswer(zone.id)}
            title={userAnswers[zone.id] ? "Cliquez pour retirer" : zone.label || "Zone de dépôt"}
            style={getZoneStyle(zone)}
          >
            {userAnswers[zone.id] ? (
              <div style={{
                background: 'white',
                padding: '2px 6px',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                gap: '3px',
                boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
                maxWidth: '100%',
                overflow: 'hidden'
              }}>
                {showCorrectAnswers && (
                  isCorrect(zone.id)
                    ? <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '12px', flexShrink: 0 }} />
                    : <CloseCircleTwoTone twoToneColor="#ff4d4f" style={{ fontSize: '12px', flexShrink: 0 }} />
                )}
                <span style={{
                  fontSize: '10px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                  {userAnswers[zone.id].content}
                </span>
              </div>
            ) : (
              <span style={{
                color: '#1890ff',
                textAlign: 'center',
                fontSize: '10px',
                opacity: 0.7
              }}>
                {zone.label || '......'}
              </span>
            )}
          </div>
        ))}

        {/* 🆕 Indicateur de correction - réponse attendue */}
        {showCorrectAnswers && dropZones.map(zone => {
          const correct = isCorrect(zone.id);
          if (correct) return null; // Pas besoin de montrer si c'est déjà correct

          const pixelPos = getZonePixelPosition(zone);

          return (
            <div
              key={`correct-${zone.id}`}
              style={{
                position: 'absolute',
                left: pixelPos.left,
                top: `calc(${pixelPos.top} + ${pixelPos.height} + 2px)`,
                fontSize: '9px',
                color: '#52c41a',
                fontWeight: '600',
                background: 'rgba(255,255,255,0.9)',
                padding: '1px 4px',
                borderRadius: '3px',
                zIndex: 3,
                whiteSpace: 'nowrap',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
              }}
            >
              ✓ {zone.correctAnswer}
            </div>
          );
        })}
      </div>

      {/* Propositions draggables */}
      <div style={{
        width: '220px',
        minWidth: '220px',
        background: '#f8f9fa',
        padding: '12px',
        borderRadius: '8px',
        border: '1px solid #e8e8e8',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <h4 style={{
          marginBottom: '10px',
          fontSize: '13px',
          color: '#1890ff',
          fontWeight: '600'
        }}>
          📦 Propositions
        </h4>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
          overflowY: 'auto',
          flex: 1
        }}>
          {propositions.map(prop => {
            const isUsed = usedPropositionIds.has(prop.id);

            return (
              <div
                key={prop.id}
                draggable={!isUsed && !showCorrectAnswers}
                onDragStart={() => !isUsed && handleDragStart(prop)}
                style={{
                  padding: '8px 10px',
                  background: isUsed ? '#f0f0f0' : 'white',
                  border: isUsed
                    ? '2px solid #d9d9d9'
                    : '2px solid #91d5ff',
                  borderRadius: '6px',
                  cursor: isUsed || showCorrectAnswers ? 'default' : 'grab',
                  fontSize: '12px',
                  fontWeight: '500',
                  textAlign: 'center',
                  transition: 'all 0.2s',
                  userSelect: 'none',
                  opacity: isUsed ? 0.5 : 1,
                  textDecoration: isUsed ? 'line-through' : 'none',
                  color: isUsed ? '#999' : '#333'
                }}
              >
                {prop.content}
              </div>
            );
          })}
        </div>

        {/* Compteur de zones remplies */}
        <div style={{
          marginTop: '10px',
          padding: '8px',
          background: 'white',
          borderRadius: '6px',
          textAlign: 'center',
          fontSize: '11px',
          color: '#666',
          border: '1px solid #e8e8e8'
        }}>
          {Object.keys(userAnswers).length} / {dropZones.length} zones remplies
        </div>
      </div>
    </div>
  );
};

export default DragDropImage;